export default __webpack_public_path__ + "static/media/IconDownload.198f9bf0.svg";